export class ElearningModule {
    courseID: number;
    categoryID: number;
    courseFullName: string;
}


// WEBPACK FOOTER //
// ./src/app/models/elearningModule.ts